import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appRightClickBlock]',
    standalone: false
})
export class RightClickBlockDirective {

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }

  constructor() { }


}
